
/** 
 * In the browser we already have a WHATWG URL constructor on window.
 * Here we re-export it as “url” so other modules can import it.
 */
const _url = typeof window !== 'undefined' ? window.URL : undefined;
export { _url as url };
/**
 * Minimal fileURLToPath implementation for browser-side code.
 * If you only ever need to strip off “file://” in development, this is enough.
 */
export function fileURLToPath(fileUrl: string): string {
  // e.g. fileUrl = "file:///Users/foo/bar.txt"
  try {
    const u = new URL(fileUrl);
    return u.pathname;
  } catch {
    // fallback: just strip file://
    return fileUrl.replace(/^file:\/\//, '');
  }
}
export {eatOuter,eatInner} from './../string_utils/index.js';
export {ensure_list} from './../type_utils/index.js';
export function getAbsolutePath(): string {
    return fileURLToPath(import.meta.url);
};